import {
  ByLocationCard,
  ByLocationCardVariantEnum,
} from '@app/feature/statistics/components/by-location-card/by-location.card';
import { useCpmsBoGetRevenueByLocationQuery } from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import { useFilters } from '../../context/filters.context';

export const RevenueByLocationCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();

  const { data } = useCpmsBoGetRevenueByLocationQuery({
    ...transformedFilters,
  });

  return (
    <ByLocationCard data={data} variant={ByLocationCardVariantEnum.Revenue} />
  );
};
